export enum PermissionValue {
    INICIO = 1,
    IDIOMAS = 2,
    CODIFICACIONES = 3,
    CENTROINVESTIGACIONES = 4,
    TIPOSCENTROINVESTIGACIONES = 5,
    ROLES = 6,
    USUARIOS = 7,
    TITULOSACADEMICOS = 8,
    AREASACADEMICAS = 9,
    SOLICITUDROLE = 10,
    TERMINOSCONDICIONES = 11,
    CONVOCATORIAS = 12,
    PERIODO = 13,
    TIPOMIEMBRO = 14,
    GASTOPRESUPUESTO = 15,
    TIPOPROYECTO = 16,
    INSTITUCION = 17,
    MONEDA = 18,
    PROPUESTASFONDOCYT = 19,
    Dashboard = 20,
    TIPOEVALUACION = 21,
    PRIORIZACIONPROPUESTA = 22,
    PROYECTOPORCONVOCATORIA = 23,
    REPORTEPORPROPUESTA = 24,
    HISTORICO = 25,
    ANNOUCEMENTTYPE = 26,
    //EDICIONEJECUCIONPRESUPUESTARIAFONDOCYT = 27,
    APROBACIONDEPROYECTOSFONDOCYT = 28,
    TIPOCONTENIDO = 29,
    PROYECTOENEJECUCION = 30,
    SEGURIDAD = 31,
    MODULOCONVOCATORIAS = 32,
    AUDITORIA = 33,
    MODULOREPORTES = 34,
    CUESTIONARIOONLINE = 35,
    CUESTIONARIOONLINEVIEW = 36
}